module.exports = __webpack_public_path__ + "img/map-djzy.fe108a7b.png";